import script from "./ToppingsScrapPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ToppingsScrapPage.vue?vue&type=script&setup=true&lang=js"

import "./ToppingsScrapPage.vue?vue&type=style&index=0&id=538976a1&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538976a1"]])

export default __exports__